import { Injectable } from '@angular/core';
import { catchError, map, Observable, shareReplay } from 'rxjs';
import { DashboardApiService } from '../db-api.service';
import { SkillFramework, SkillFrameworkType } from '../../entities/skills-framework.model';

const FRAMEWORKS_URL = '/v1/corporation/skill_frameworks';

@Injectable({
  providedIn: 'root',
})
export class CorporationSkillFrameworksApiService extends DashboardApiService {
  private _externalFrameworks$: Observable<SkillFramework[]> | null = null;

  getFramework(id: number): Observable<SkillFramework> {
    return this._get(`${FRAMEWORKS_URL}/${id}`).pipe(
      map((res) => this._handleResponse(res, 'skill_framework')),
      catchError((res) => this._handleError(res)),
    );
  }

  listFrameworks(type?: SkillFrameworkType): Observable<SkillFramework[]> {
    const endpoint = type ? `${FRAMEWORKS_URL}?type=${type}` : FRAMEWORKS_URL;

    return this._get(endpoint).pipe(
      map((res) => this._handleResponse(res, 'skill_frameworks')),
      catchError((res) => this._handleError(res)),
    );
  }

  listExternalFrameworks(): Observable<SkillFramework[]> {
    if (!this._externalFrameworks$) {
      this._externalFrameworks$ = this.listFrameworks('external').pipe(shareReplay(1));
    }
    return this._externalFrameworks$;
  }
}
